import * as yup from "yup";

const scopeKeys = ["add", "update", "view", "delete"];

export const roleSchema = yup.object().shape({
  name: yup.string().required("Role name is required"),
  description: yup.string(),
  permissions: yup.array().of(
    yup.object().shape({
      module_name: yup.string().required("Module name is required"),
      module_slug: yup.string().required("Module slug is required"),
      scopes: yup.array().of(
        yup.object().shape({
          key: yup
            .string()
            .oneOf(scopeKeys, "Invalid scope key")
            .required("Scope key is required"),
          value: yup.boolean().default(false),
        })
      ),
      permission_key: yup.array(),
    })
  ),
});
